import React, { Component } from "react";
import "./Footer.css";

export default class Footer extends Component {
  //The application's footer.
  render() {
    return <div className="footer navbar navbar-bottom" />;
  }
}



// WEBPACK FOOTER //
// ./src/containers/Footer.js